import React from "react";

import "./EPlaceholder.scss";

interface IProps {
  iconSrc?: string;
  title: string;
  description?: string;
}

export function EPlaceholder(props: any) {
  return (
    <div className="max-w-lg mx-auto flex flex-col items-center text-center rounded-xl p-6">
      <div className="icon mb-4 bg-blue-50 p-4 shadow-sm rounded-3xl">
        <img className="w-14 h-14" src={props?.iconSrc ? props.iconSrc : "/undraw_no-data_ig65.svg"} alt="" />
      </div>
      <div className="text-group">
        <div className="title text-base font-semibold text-slate-900">
          {props.title}
        </div>
        <div className="description text-slate-500 mt-1">
          {props.description}
        </div>
      </div>
    </div>
  );
}